export enum RefundEligibilityReason {
    // Eligible
    TWENTY_FOUR_HOUR_REFUND_ELIGIBLE= 'TWENTY_FOUR_HOUR_REFUND_ELIGIBLE',
    // Ineligible
    REFUND_INELIGIBLE= 'REFUND_INELIGIBLE'
}
